import React, { Component } from 'react';
import { FormGroup, Input, Button, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { data } from '../../constants/Constants';
import { getCatalogo, setIncidente } from '../../store/sagas/catalogoApi';
import localStorageCustom from '../../utilitarios/localStorage';
import { notificacion } from '../../utilitarios/util';
import { AuthContext } from "../../store/provider/AuthProvider";
import Spinner from "../reusable/Loader";

function Step1({ dadComponent }) {
  const { } = dadComponent.state;
  return (
    <div>
      <div className="card card_container">
        <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
        <div className="m-auto" style={{maxWidth:600}}>
          <p className="paragraph-2 light">Para asegurarte de estar en la opción correcta, te brindamos ejemplos de algunos escenarios que puedes registrar aquí:</p>
          <ul className="list-incidente card_desktop">
            <li>¿Te hemos facturado un cobro del que no estás de acuerdo?</li>
            <li>¿Tu Pedido nunca te llegó?</li>
            <li>¿Tu Pedido llegó en mal estado?</li>
          </ul>
          <div className="text-center mt-5 mobile">
            <button className='btn-block red' onClick={() => dadComponent.nextStep()}>Reportar tu<br />indicente aquí</button>
          </div>
        </div>
      </div>
      <div className="text-center mt-5 desktop">
        <button className='btn-block red' style={{maxWidth: 300}} onClick={() => dadComponent.nextStep()}>Reportar tu indicente aquí</button>
      </div>
    </div>
  )
}

function Step2({ dadComponent }) {
  let { email } = dadComponent.state;
  return (
    <div>
      <div className="card card_container">
        <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
        <div className="m-auto" style={{maxWidth:750}}>
          <p className="paragraph-2 light">Estamos para ayudarte, cuéntanos tu inconveniente y te ayudaremos a resolverlo.</p>
          <p className="paragraph-2 light">Para completar tu incidente, ingresar el Email que usas para ingresar al app de Crosland.</p>
          <form style={{maxWidth:280}} className="mx-auto">
            <FormGroup className="mt-5">
              <Input className="azul" type='text' value={email} disabled={true} />
            </FormGroup>
          </form>
          <div className="text-center mt-5 mobile">
            <button className={`btn-block red${(email=="" || email==null ? " disabled" : "")}`}  disabled={email=="" || email==null} onClick={() => { dadComponent.nextStep() }}>siguiente</button>
          </div>
        </div>
      </div>
      <div className="text-center mt-5 desktop">
        <button className={`btn-block red${(email=="" || email==null ? " disabled" : "")}`}  disabled={email=="" || email==null} onClick={() => { dadComponent.nextStep() }}>siguiente</button>
      </div>
    </div>
  )
}

function Step3({ dadComponent }) {
  let { incidentes, text, id, errorValidacopn } = dadComponent.state;

  return (
    <div>
      <div className="card card_container">
        <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
        <div className="m-auto" style={{maxWidth:440}}>
          <p className="paragraph-2 light">Por favor seleccione el Incidente.</p>
          <ul className="select-incidente">
            {incidentes.map((item, index) => {
              return (
                <li key={index}>
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id={`radio${index}`}
                      name="incidente"
                      className="custom-control-input"
                      checked={item.id == id}
                      onChange={() => dadComponent.setIncidente(item)} />
                    <label className="custom-control-label" htmlFor={`radio${index}`}>{item.descripcion}</label>
                  </div>
                </li>
              )
            })}
          </ul>
          <FormGroup className="mt-5">
            <Input type='textarea' rows="4" placeholder="Otros" value={text} onChange={(e) => {let text = e.currentTarget.value;dadComponent.setText(text);}} />
          </FormGroup>
          <div className="text-center mt-5 mobile">
            <button style={{backgroundColor:c.verde}} className={`btn-block ${(id==0 || text=="" || text==null ? " disabled" : "")}`} onClick={() => dadComponent.RegistrarIncidente()} disabled={id==0 || text=="" || text==null}>Enviar</button>
          </div>
        </div>
      </div>
      <div className="text-center mt-5 desktop">
        <button style={{backgroundColor:c.verde}} className={`btn-block ${(id==0 || text=="" || text==null ? " disabled" : "")}`} onClick={() => dadComponent.RegistrarIncidente()} disabled={id==0 || text=="" || text==null}>Enviar</button>
      </div>
    </div>
  )
}

function Step4({ dadComponent, auth }) {
  const { } = dadComponent.state;
  
  return (
    <div>
      <div className="card card_container">
          <div className="empty" style={{maxWidth:560}}>
            <SvgAssets icon="icon-like" fill={c.celeste} />
            <h6 className="paragraph-1 mb-2" style={{ color: c.azulClaro }}>MUCHAS GRACIAS</h6>
            <p className="paragraph-2 text-center">Hola {auth.userRazonSocial}, muchas gracias por registrar tu incidente, en un máximo de 72 horas nos comunicaremos contigo.</p>
            <div className="text-center mt-5 mobile">
              <Link to="/dashboard">
              <button className='btn-block' style={{ backgroundColor: c.azulClaro }}>ENTENDIDO</button>
              </Link>
            </div>
          </div>
      </div>
      <div className="text-center mt-5 desktop" style={{ justifyContent: 'center' }}>
        <Link to="/dashboard">
          <button className='btn-block' style={{ backgroundColor: c.azulClaro }}>ENTENDIDO</button>
        </Link>
      </div>
    </div>
  )
}

export class Incidente extends Component {
  static displayName = Incidente.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      loading: true,
      incidentes: [],
      id: 0,
      text: "",
      errorValidacopn: null,
      email: null
    };
    // this.nextStep = this.nextStep.bind(this);
    this.backStep = this.backStep.bind(this);
  }
  
  componentDidMount() {
    window.scrollTo(0, 0)
    let result = localStorageCustom.prototype.getUsuario();
    this.setState({ email: result.dealer.correoElectronico }, () => {
      this.getIncidentes(data.Incidentes);
    });
  }

  nextStep() {
    this.setState({ step: this.state.step + 1 })
  }
  
  backStep() {
    this.setState({ step: this.state.step - 1 })
  }

  renderStep() {
    const auth = this.context;
    switch (this.state.step) {
      case 0:
        return <Step1 dadComponent={this} />
        case 1:
          return <Step2 dadComponent={this} />
          case 2:
        return <Step3 dadComponent={this} />
      case 3:
        return <Step4 dadComponent={this} auth={auth} />
        default:
        return <Step1 dadComponent={this} />
      }
    }
    
    render() {
      const { loading, step } = this.state;
    return (
      <div>
        <div className="title_banner">
            <Container>
              <h1>Incidente</h1>
            </Container>
            <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
          </div>
          <div className="breadcrumb">
            <Container>
              <ul>
                <li><Link to='/dashboard'>Dashboard</Link></li>
                <li>Ayuda</li>
                <li>Incidente</li>
              </ul>
            </Container>
          </div>
        <Container className="py-5">
          <Spinner visible={loading} />
          <h6 className="title white mobile">
            {step != 3?
              <a onClick={this.backStep} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></a> : null
            }
            INCIDENTE
          </h6>
          {this.renderStep()}
        </Container>
      </div>
    );
  }

  setIncidente = (item) => {
    this.setState({ id: item.id, errorValidacopn: "" })
  }

  setText = (value) => {
    this.setState({ text: value, errorValidacopn: "" })
  }

  RegistrarIncidente = () => {
    if (this.state.id == 0)
      this.setState({ errorValidacopn: "Debe seleccionar el incidente" })
    else if (this.state.text == null || this.state.text == "")
      this.setState({ errorValidacopn: "Debe ingresar el incidente" })
    else {
      this.setState({ errorValidacopn: "" })
      let storageGeneral = localStorageCustom.prototype.getUsuario();
      this.postIncidentes(storageGeneral.dealer.codcliente, storageGeneral.dealer.correoElectronico,
        this.state.text, this.state.id
      )
    }

  }

  getIncidentes = (Incidentes) => {
    getCatalogo(Incidentes,data.PerfilLinea.Repuestos)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false, incidentes: result.listDto })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Incidentes", error.message ?? null);
        });
      });

  }
  postIncidentes = (CodigoDealer, CorreoElectronico, Comentario, IncidenteId) => {
    this.setState({
      loading: true,
      data: { id: 0, text: null, errorValidacopn: null }
    })
    setIncidente(CodigoDealer, CorreoElectronico, Comentario, IncidenteId)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            id: 0, text: null, errorValidacopn: null
          })

          this.nextStep();
          // this.props.navigation.navigate('AyudaGracias');
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Incidentes", error.message ?? null);
        });
      });

  }
}
